import { useProgramContentOverride } from '../contexts/DrugProgramProvider';
import type { FillPathway } from '../contexts/fill';
import type {
    AuthorizedMedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../graphql/generated/graphql';
import type { DrugKeyType } from '../util/config/constants';

import { useDrugKey } from './use-drug-key';

export const useProgramTerms = (
    medication:
        | AuthorizedMedicationInfoFragment
        | UnknownMedicationInfoFragment,
    pathway: FillPathway | null
) => {
    const drugKey = useDrugKey(medication);

    return useProgramTermsByDrugKey(drugKey, pathway);
};

export const useProgramTermsByDrugKey = (
    drugKey: DrugKeyType | null,
    pathway: FillPathway | null
) => {
    const content = useProgramContentOverride();

    if (!pathway) {
        return null;
    }

    const terms = drugKey ? content.terms[drugKey] : null;

    return terms?.[pathway] ?? null;
};
